import { render, staticRenderFns } from "./Propuesta.vue?vue&type=template&id=01bf6f1c&scoped=true"
import script from "./Propuesta.vue?vue&type=script&lang=js"
export * from "./Propuesta.vue?vue&type=script&lang=js"
import style0 from "./Propuesta.vue?vue&type=style&index=0&id=01bf6f1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bf6f1c",
  null
  
)

export default component.exports